// extracted by mini-css-extract-plugin
export default {"rectangle":"slider_rectangle__afLtu","box":"slider_box__zqo4B","arrow":"slider_arrow__YTngo","values":"slider_values__ZNTSG"};